import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';

export const StyledToastContainer = styled(ToastContainer)`
  padding: ${props => props.theme.spacing(1)};

  .Toastify__toast {
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    min-height: initial;
    color: #333;
    border: 1px solid ${props => props.theme.palette.grey[500]};
    border-left: 16px solid ${props => props.theme.palette.grey[500]};
    background-color: #fff;

    &-body {
      font-weight: 500;
    }
  }

  .Toastify__close-button {
    align-self: initial;
    color: #333;
    padding-left: 10px;
  }

  .Toastify__toast--info {
    border-left-color: ${props => props.theme.palette.secondary.main};

    & .Toastify__progress-bar {
      background-color: ${props => props.theme.palette.secondary.main};
    }
  }
  .Toastify__toast--error {
    border-left-color: ${props => props.theme.palette.error.main};
    & .Toastify__progress-bar {
      background-color: ${props => props.theme.palette.error.main};
    }
  }
  .Toastify__toast--warning {
    border-left-color: ${props => props.theme.palette.warning.main};
    & .Toastify__progress-bar {
      background-color: ${props => props.theme.palette.warning.main};
    }
  }
  .Toastify__toast--success {
    border-left-color: ${props => props.theme.palette.success.main};
    & .Toastify__progress-bar {
      background-color: ${props => props.theme.palette.grey[300]};
    }
  }
`;
